import * as fromRouter from '@ngrx/router-store';
import { DefaultProjectorFn, MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { RouteId } from 'src/app/app.routes';
import { GUID } from 'src/app/core/types';

export const selectRouter = createFeatureSelector<
  fromRouter.RouterReducerState
>('router');

//   selectCurrentRoute,
//   selectQueryParams,    // select the current route query params
//   selectQueryParam,     // factory function to select a query param
//   selectRouteParams,    // select the current route params
//   selectRouteParam,     // factory function to select a route param
//   selectRouteData,      // select the current route data
//   selectUrl,            // select the current url
const routerSelectors = fromRouter.getRouterSelectors(selectRouter);

export const selectRouteParam = routerSelectors.selectRouteParam
export const selectUrl = routerSelectors.selectUrl
export const selectQueryParam = routerSelectors.selectQueryParam
export const selectQueryParams = routerSelectors.selectQueryParams

export const selectReturnUrl = routerSelectors.selectQueryParam('ReturnURL')
export const selectMailSent = routerSelectors.selectQueryParam('mailSent')

// OrderId can be either in QueryString (Admin-Cart) or RouteParam (OrderStatus/OrderSuccess-Page)
export const selectOrderIdQueryString = routerSelectors.selectQueryParam('OrderId') as MemoizedSelector<object, GUID | undefined, DefaultProjectorFn<GUID | undefined>>
export const selectOrderIdStatusPage = selectRouteParam('OrderIdStatus') as MemoizedSelector<object, GUID | undefined, DefaultProjectorFn<GUID | undefined>>
export const selectOrderIdSuccessPage = selectRouteParam('OrderIdSuccess')

export const selectRouteTranslationKey = createSelector(
  routerSelectors.selectRouteData,
  routeData => routeData && (routeData['titleTranslationKey'] as string)
)

export const selectRouteId = createSelector(
  routerSelectors.selectRouteData,
  routeData => routeData && (routeData['routeId'] as RouteId)
)

export const selectOrderId = createSelector(
  selectOrderIdQueryString,
  selectOrderIdStatusPage,
  (queryString: GUID | undefined, routeParam: GUID | undefined) => {
    return queryString || routeParam
  }
)

export const selectAdminCartMode = createSelector(
  selectOrderIdQueryString,
  id => !!id
)

export const selectShowRootNodes = createSelector(
  routerSelectors.selectQueryParam('ShowRootNodes'),
  ids => (ids as string | undefined)?.split(',').map(Number)
)

export const selectIsAdminRoute = createSelector(
  selectRouter,
  r => r?.state?.root?.firstChild?.url[1]?.path === 'Admin'
)

export const selectIsInfoScreenRoute = createSelector(
  selectRouter,
  r => r?.state?.root === undefined ? undefined : r?.state?.root?.firstChild?.url[0]?.path.toLowerCase() === 'infoscreen'
)
